import TableTopBox from './TableTopBox/index.vue';
import Print from 'vue-print-nb';
import TagsView from './TagsView';
export { default as FormDialog } from "./FormDialog/index.vue";
export { default as AreaSelect } from "./AreaSelect/index.vue";
export { default as GridDisplay } from "./GridDisplay/index.vue";
export { default as SearchBar } from "./SearchBar/index.vue";
export { default as SimpleTable } from "./SimpleTable/index.vue";
export default {
  install: function install(Vue) {
    // 注册全局的通用栏组件对象
    Vue.component('TableTopBox', TableTopBox); //tab栏切换组件
    Vue.component('TagsView', TagsView); //tab栏切换组件
    Vue.use(Print); // 注册打印组件
  }
};